const ExclamationIcon = (props) => {
    return (
        <svg
          width={16}
          height={15}
          viewBox="0 0 16 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#clip0_8_96)" fill="#fff">
            <path d="M9.655 11.25h-2.67a.635.635 0 00-.469.202.663.663 0 00-.198.48v2.386c0 .185.066.345.198.48a.636.636 0 00.47.202h2.669c.18 0 .337-.068.469-.202a.664.664 0 00.198-.48v-2.386a.663.663 0 00-.198-.48.635.635 0 00-.47-.202zM10.452.202A.619.619 0 009.988 0H6.652a.618.618 0 00-.464.202.635.635 0 00-.182.48l.292 8.181a.692.692 0 00.213.48.651.651 0 00.475.202h2.669c.18 0 .338-.067.474-.202a.694.694 0 00.214-.48l.291-8.181a.634.634 0 00-.182-.48z" />
          </g>
          <defs>
            <clipPath id="clip0_8_96">
              <path fill="#fff" transform="translate(.98)" d="M0 0H14.6788V15H0z" />
            </clipPath>
          </defs>
        </svg>
      )
}

export default ExclamationIcon